/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Panel',
  components: {},
  props: {
    list: Array,
    selectedValue: Array
  },
  data: function data() {
    return {};
  },
  computed: {
    selectedValueArr: function selectedValueArr() {
      return this.selectedValue.map(function (v) {
        return v.id;
      });
    }
  },
  methods: {
    change: function change(item, index) {
      this.$emit('on-change', item, index);
    }
  }
};